module.exports = __webpack_public_path__ + "static/img/ArcelorMittal_G9A3017.4aa6f24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/ArcelorMittal_G9A3017.jpg
// module id = VJbG
// module chunks = 0